import { useState, useEffect, useCallback } from 'react';
import toast from 'react-hot-toast';

export function useSupabase(fetchFn, dependencies = []) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      console.log('🔄 Fetching data...');
      const result = await fetchFn();
      console.log('✅ Data fetched:', result);
      setData(result || []);
      return result;
    } catch (err) {
      console.error('❌ Error fetching data:', err);
      setError(err.message);
      toast.error(`Failed to fetch data: ${err.message}`);
      return null;
    } finally {
      setLoading(false);
    }
  }, [fetchFn]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { 
    data, 
    loading, 
    error, 
    refetch: fetchData 
  };
}